import { Order, OrderResponse, OrdersUpdateRequest } from 'src/models/Order'
import { getOrderingServerUrl } from 'src/utils/env'

import { HttpClientBase } from './HttpClientBase'
import { OrderingHttpClientInterface } from './HttpClientInterface'
import { CustomerResponse } from './types'

export class OrderingHttpClient extends HttpClientBase implements OrderingHttpClientInterface {
    constructor() {
        super({
            baseURL: `${getOrderingServerUrl()}/api/v2`,
        })
    }

    async getCustomer(): Promise<CustomerResponse> {
        return this.get<CustomerResponse>('/customer', {
            withCredentials: true,
        })
    }

    async getOrder(orderId: string): Promise<Order> {
        const response = await this.get<OrderResponse>(`/orders/${orderId}`, {
            withCredentials: true,
        })

        return response.order
    }

    async updateOrder(orderId: string, payload: OrdersUpdateRequest): Promise<Order> {
        const response = await this.patch<OrderResponse>(`/orders/${orderId}`, {
            withCredentials: true,
            data: payload,
        })

        return response.order
    }
}
